// Sidebar.js
import React, { useState } from 'react';
import { View, Text, TouchableOpacity, Image, StyleSheet, Animated } from 'react-native';
import { Feather } from '@expo/vector-icons';
import styles from './styles/styles';  // Import the styles

const Sidebar = ({ activeLink, handleLinkPress, onClose }) => {
  const [expanded, setExpanded] = useState(true);
  const sidebarWidth = useState(new Animated.Value(180))[0];  // Initial width

  const toggleSidebar = () => {
    Animated.timing(sidebarWidth, {
      toValue: expanded ? 60 : 180,  // Collapse or expand
      duration: 300,
      useNativeDriver: false,
    }).start();
    setExpanded(!expanded);
  };

  const links = [
    { label: 'About Us', screen: 'AboutUs', icon: 'info' },
    { label: 'Success Stories', screen: 'SuccessStories', icon: 'star' },
    { label: 'For Business', screen: 'Service', icon: 'layers' },
    { label: 'Culture', screen: 'Culture', icon: 'smile' },
    { label: 'Careers', screen: 'Career', icon: 'award' },
    { label: 'Contact', screen: 'Contact', icon: 'mail' }, 
  ];

  return (
    <Animated.View style={[styles.sidebar, { width: sidebarWidth, paddingTop: 120 }]}>
    

      {links.map(link => (
        <TouchableOpacity
          key={link.screen}
          onPress={() => handleLinkPress(link.screen)}
          style={styles.menuItemWrapper}
        >
          <Feather name={link.icon} size={18} color="#ccc" />
          {expanded && (
            <Text style={[styles.menuItem, activeLink === link.screen && styles.activeMenuItem]}>
              {link.label}
            </Text>
          )}
        </TouchableOpacity>
      ))}
    </Animated.View>
  );
};




export default Sidebar;
